import { useState } from 'react';

export default (initialState) => {
  const [formData, setFormData] = useState(initialState);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], value: name === 'email' ? value.replaceAll(' ', '') : value }
    }));
  };

  const handleValidation = (event, customValidation = true) => {
    const { name, value } = event.target;
    // input length needs to be atleast 2 because gateway rejects names shorter than 2 characters
    const valid = value.trim().length > 1 && customValidation;
    setFormData((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], valid }
    }));
  };

  //* this is for catching error from the CreditCardInput, since onError does not return event.target
  const handleCreditCardError = (name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], valid: false }
    }));
  };

  return [formData, handleChange, handleValidation, handleCreditCardError];
};
